/* eslint-disable @typescript-eslint/no-explicit-any */
import AbstractService from '../abstract-service';
import AddToCartParametersInterface from '../../vo/event/add-to-cart-parameters-interface';
import CheckoutParametersInterface from '../../vo/event/checkout-parameters-interface';
import ClickEventParametersInterface from '../../vo/event/click-event-parameters-interface';
import EventParametersInterface from '../../vo/event/event-parameters-interface';
import ItemViewParametersInterface from '../../vo/event/item-view-parameters-interface';
import MicrosoftConfigurationDto from '../../vo/microsoft/microsoft-configuration-dto';
import MicrosoftConfigurationInterface from '../../vo/microsoft/microsoft-configuration-interface';
import OrderParametersInterface from '../../vo/event/order-parameters-interface';
import PageViewParametersInterface from '../../vo/event/page-view-parameters-interface';
import ServiceInterface from '../service-interface';
import SubmitEventParametersInterface from '../../vo/event/submit-event-parameters-interface';

declare global
{
    interface Window
    {
        uetq: any;
    }
}

declare let UET: any;

export default class MicrosoftAds extends AbstractService implements ServiceInterface
{
    protected configuration: MicrosoftConfigurationInterface;

    public constructor(configuration: MicrosoftConfigurationInterface)
    {
        super(configuration);

        this.configuration = Object.assign(new MicrosoftConfigurationDto(), configuration);
    }

    public define(): void
    {
        if (this.defined)
        {
            return;
        }

        const config = this.configuration;

        // Disable eslint as this block comes directly from Microsoft Ads
        /* eslint-disable */
        (function(
            w: any, d: any, t: any, r: any, u: any,
        )
        {
            let f: any;
            let n: any;
            let i: any;

            w[u] = w[u] || [], f = function()
            {
                const o = {
                    ti: config.key,
                    enableAutoSpaTracking: config.enableAutoSpaTracking,
                    q: null
                };

                o.q = w[u],
                w[u] = new UET(o),
                w[u].push('pageLoad');
            },
            n = d.createElement(t),
            n.src = r,
            n.async = 1,
            n.onload = n.onreadystatechange = function()
            {
                const s = this.readyState;
                s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null);
            },
            i = d.getElementsByTagName(t)[0],
            i.parentNode.insertBefore(n, i);
        })
        (
            window, document, 'script', '//bat.bing.com/bat.js', 'uetq',
        );
        /* eslint-enable */

        window.uetq = window.uetq || [];

        if (this.configuration.debug)
        {
            console.log('Microsoft Ads', this.configuration.key);
        }

        this.defineConsent();
        this.defineEnhanced();

        this.setDefined();
    }

    public defineConsent()
    {
        if (this.defined)
        {
            return;
        }

        const consentString = this.configuration.consent ? 'granted' : 'denied';

        window.uetq.push(
            'consent', 'update', {
                ad_storage: consentString,
            },
        );

        if (this.configuration.debug)
        {
            console.log('Microsoft Ads Consent', consentString);
        }
    }

    public defineEnhanced()
    {
        if (this.defined || !this.configuration.enhanced)
        {
            return;
        }

        if (!this.configuration.email || !this.configuration.phone)
        {
            return;
        }

        window.uetq.push('set', { pid: {
            em: this.configuration.email,
            ph: this.configuration.phone,
        } });

        if (this.configuration.debug)
        {
            console.log(
                'Microsoft Ads Enhanced', this.configuration.email, this.configuration.phone,
            );
        }
    }

    public trackEvent(event: string, parameters: EventParametersInterface): void
    {
        window.uetq = window.uetq || [];

        const eventParameters = this.getEventParameters(parameters);

        window.uetq.push(
            'event', event, eventParameters,
        );

        if (this.configuration.debug)
        {
            console.log(
                'Microsoft Ads Event', event, eventParameters,
            );
        }
    }

    protected getEventParameters(parameters: EventParametersInterface): { [key: string]: string|number|boolean }
    {
        const eventParameters: { [key: string]: string|number|boolean|null } = {};

        if (parameters.category)
        {
            eventParameters.event_category = parameters.category;
        }

        if (parameters.label)
        {
            eventParameters.event_label = parameters.label;
        }

        if (parameters.value)
        {
            eventParameters.event_value = parameters.value;
        }

        return this.filterParameters(eventParameters);
    }

    public trackOrder(order: OrderParametersInterface): void
    {
        if (!order.value)
        {
            return;
        }

        const currency = order.currency || 'GBP';

        window.uetq.push(
            'event', '', { revenue_value: order.value,
                currency },
        );

        if (this.configuration.debug)
        {
            console.log(
                'Microsoft Ads Order', order.value, currency,
            );
        }
    }

    /* eslint-disable @typescript-eslint/no-unused-vars */
    public trackPageView(parameters: PageViewParametersInterface): void
    {
        // Not supported
    }

    public trackAddToCart(parameters: AddToCartParametersInterface): void
    {
        // Not supported
    }

    public trackCheckout(parameters: CheckoutParametersInterface): void
    {
        // Not supported
    }

    public trackClick(parameters: ClickEventParametersInterface): void
    {
        // Not supported
    }

    public trackSubmission(parameters: SubmitEventParametersInterface): void
    {
        // Not supported
    }

    public trackItemView(parameters: ItemViewParametersInterface): void
    {
        // Not supported
    }

    public trackRemoveFromCart(parameters: AddToCartParametersInterface): void
    {
        // Not supported
    }

    public trackAddToWishlist(parameters: ItemViewParametersInterface): void
    {
        // Not supported
    }
}